<template>
  <article class="panel change-message-visibility-modal">
    <NrModal
      class="change-message-visibility"
      primary-button-text="Change message visibility"
      secondary-button-text="Cancel"
      title="Change Message Visibility"
      :has-secondary-button="true"
      :show="!!active"
      @on-close-click="$emit('on-close-message-visibility-modal')"
      @on-primary-click="updateMessageVisibility"
      @on-secondary-click="$emit('on-close-message-visibility-modal')"
    >
      You are about to change the visibility of a message. This will affect who
      can see the message on the timeline of this request.

      <NrSelect
        v-model="messageVisibility"
        placeholder="Select message visibility"
        :options="messageVisibilities"
        :clearable="false"
        appendToBody
      >
        <template v-slot:label>Visibility</template>
      </NrSelect>
    </NrModal>
  </article>
</template>

<script>
import NrModal from '@nextrequestco/components/src/components/NrModal'
import NrSelect from '@nextrequestco/components/src/components/NrSelect'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ChangeMessageVisibilityModal',
  components: {
    NrModal,
    NrSelect
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    selectedMessage: {
      type: Object
    }
  },
  data() {
    return {
      messageVisibility: '',
      messageVisibilities: [
        {
          value: 'public',
          label: 'Anyone with access to this request',
          textColor: 'green'
        },
        { value: 'requester', label: 'Requester + Staff' },
        { value: 'staff', label: 'Staff Only' }
      ]
    }
  },
  watch: {
    selectedMessage(newVal, _) {
      if (newVal) {
        this.messageVisibility = newVal
          ? {
              value: newVal.timeline_type,
              label: newVal.timeline_state,
              textColor: newVal.timeline_type === 'public' ? 'green' : ''
            }
          : ''
      }
    }
  },
  computed: {
    ...mapGetters('request_show', ['request'])
  },
  methods: {
    ...mapActions('request_show', ['updateMessage']),
    updateMessageVisibility() {
      const payload = {
        request_event_id: this.selectedMessage.timeline_id,
        request_id: this.request.pretty_id,
        message_state: this.messageVisibility.value
      }
      this.updateMessage(payload)
        .then(() => {
          this.$toasted.success('Message visibility updated successfully.')
          this.$emit('on-close-message-visibility-modal')
          this.messageVisibility = ''
        })
        // eslint-disable-next-line no-unused-vars
        .catch((_err) => {
          this.$toasted.error(
            'An error has occured while updating the message. Please try again.'
          )
        })
    }
  }
}
</script>
